import { render } from "./ScpmTabBox.vue?vue&type=template&id=6d1dea0c&scoped=true"
import script from "./ScpmTabBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ScpmTabBox.vue?vue&type=script&setup=true&lang=js"

import "./ScpmTabBox.vue?vue&type=style&index=0&id=6d1dea0c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1dea0c"],['__file',"src/containers/logs/logCollections/components/ScpmTabBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1dea0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1dea0c', __exports__)) {
    api.reload('6d1dea0c', __exports__)
  }
  
  module.hot.accept("./ScpmTabBox.vue?vue&type=template&id=6d1dea0c&scoped=true", () => {
    api.rerender('6d1dea0c', render)
  })

}


export default __exports__